export const API_SUBSCRIPTION_PLANS = '/api/plans/request';
export const API_UPDATE_SUBSCRIPTION = '/api/plan/update';
